import React from 'react';
import i18n from '../../i18n';

export default function Lang() {
  const [activeLang, setActiveLang] = React.useState(0);

  const languages = [
    { lang: 'en', img: './img/lang/us.png' },
    { lang: 'ua', img: './img/lang/ua.png' },
  ];

  const onChangeLang = (lang: string, index: number) => {
    setActiveLang(index);
    i18n.changeLanguage(lang);
  };

  localStorage.setItem('lngselected', JSON.stringify(languages[activeLang]));

  return (
    <div className="lang">
      <div className="lang__wrap">
        {languages.map((lang, index) => (
          <div
            key={index}
            className={`lang__item ${index === activeLang ? 'lang__item-active' : ''}`}
            onClick={() => onChangeLang(lang.lang, index)}>
            <img src={lang.img} alt="ua" className="lang__img" /> {lang.lang}
          </div>
        ))}

        {/* <div className="lang__item lang__item-active">
          <img src="./img/lang/ua.png" alt="ua" className="lang__img" /> UA
        </div>

        <div className="lang__item">
          <img src="./img/lang/us.png" alt="us" className="lang__img" /> US
        </div> */}
      </div>
    </div>
  );
}
